module.exports = __webpack_public_path__ + "static/img/rw.7fe5146b.svg";